import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=5fb5888d&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=js&"
export * from "./UploadForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=5fb5888d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5888d",
  null
  
)

export default component.exports
import {QCardSection,QForm,QScrollArea,QSelect,QInput,QIcon,QPopupProxy,QDate,QFile,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QForm,QScrollArea,QSelect,QInput,QIcon,QPopupProxy,QDate,QFile,QBtn})
